import Vue from "vue";
import moment from 'moment';
import store from '../store';

Vue.filter('date', function (dateStr) {
  return dateStr ? moment(dateStr).format(store.state.mainConfig.dateFormat) : null;
})
